import Vue from 'vue'
import App from './App'
import router from './router'
import api from './http'
import i18n from './i18n'
import store from './store'
import global from '@/common/global'
import _ from "lodash"

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'

Vue.config.productionTip = false;
Vue.use(ElementUI,{
  i18n: (key, value) => i18n.t(key, value)
})  // 注册使用Element
Vue.use(api)  // 注册使用API模块

Vue.prototype.global = global // 挂载全局配置模块

Vue.prototype._ = _;


//main.js


// import VueElectron from 'vue-electron'
// Vue.use(VueElectron)



new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js